
import { mapState } from 'vuex'
import reportPop from '~/components/discover/reportPop.vue' // 举报
export default {
  name: 'CommentsHead',
  components: {
    'report-pop': reportPop
  },
  props: {
    commentid: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      report: [],
      showReport: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    console.log('评价头', this.info)
  },
  methods: {
    async reportseal(reportInfo) {
      // 举报提交
      const parm = {
        postsId: this.commentid,
        userId: this.$store.state.user.userId ? this.$store.state.user.userId : '',
        reasonCode: reportInfo.code
      }
      const res = await this.$api.common
        .CV3(parm, {
          Routes: 'wikicommunity$postsreport'
        })
        .catch((err) => {
          this.$fxlog(`评价举报提交异常,${err},入参:${JSON.stringify(parm)},返回:${JSON.stringify(res)}`, window.location.href, this.$store.state.LanguageCode, '', res && res.message && !res.succeed ? 'ERROR' : '')
        })

      if (res?.wikicommunity?.postsreport?.success) {
        this.$message({
          message: this.$v('举报成功'),
          type: 'success',
          duration: 1500
        })
        this.$refs.reportpop.setreportPop()
      }
    },
    async popmenu() {
      if (!this.$store.state?.user?.userId) {
        this.$store.commit('loginClose', true)
        return false
      }

      const resean = await this.$api.common
        .CV3(
          {},
          {
            Routes: 'wikicommunity$reportreason'
          }
        )
        .catch((err) => {
          console.log(err)
        })
      this.report = resean?.wikicommunity?.reportreason?.data || []
      this.showReport = true

      this.$nextTick(() => {
        this.$refs.reportpop.setreportPop()
      })
    },
    getLine2txt() {
      let txt = ''
      let timeAfterLabel = ''
      const lizhi = this.info?.isLeaveOffice ? this.info?.leaveOfficeShow || this.$v('已离职') : ''
      const zhiwei = this.info?.positionName
      const company = this.info?.shortName
      if (company && lizhi) {
        timeAfterLabel = `<span>${company}</span><span style="background-color:#f3f3f3;padding:0px 4px;margin:0px 4px;">${lizhi}</span>`
      } else if (company && zhiwei) {
        timeAfterLabel = `<span>${company}</span><span> · </span><span>${zhiwei}</span>`
      } else if (company) {
        timeAfterLabel = `<span>${company}</span>`
      }
      if (timeAfterLabel && this.info?.registerLong) {
        txt += `<span>${timeAfterLabel}</span><span> · </span><span>${this.info?.registerLong}</span>`
      } else if (timeAfterLabel) {
        txt += `<span>${timeAfterLabel}</span>`
      } else if (this.info?.registerLong) {
        txt += `<span>${this.info?.registerLong}</span>`
      }
      return txt
    },
    gotopersonpage(e) {
      if (this.info?.userid) {
        window.open(`/${this.$store.state.LanguageCode}/information/${this.info?.userid}.html`)
      }
      e.stopPropagation()
      return false
    }
  }
}
